import { APIComponentType, ArdoqId } from '@ardoq/api-types';
import { isEqual } from '@ardoq/common-helpers';
import { modelOperations } from '@ardoq/core';
import { WorkspaceAndModelLookup } from '@ardoq/data-model';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';
import { workspaceAndModel$ } from 'streams/workspaceAndModel$';

export type ComponentTypesByWorkspaceId = Readonly<
  Record<ArdoqId, readonly APIComponentType[]>
>;

export const mapComponentTypesByWorkspaceId = <T>(
  componentTypesByWorkspaceId: ComponentTypesByWorkspaceId,
  fn: (componentType: APIComponentType) => T
): Record<ArdoqId, T[]> => {
  const result: Record<ArdoqId, T[]> = {};
  for (const [workspaceId, componentTypes] of Object.entries(
    componentTypesByWorkspaceId
  )) {
    result[workspaceId] = componentTypes.map(fn);
  }
  return result;
};

const buildComponentTypesByWorkspaceId = ({
  workspacesById,
  modelsById,
}: WorkspaceAndModelLookup): ComponentTypesByWorkspaceId => {
  const componentTypesByWorkspaceId: Record<ArdoqId, APIComponentType[]> = {};
  for (const [workspaceId, workspace] of Object.entries(workspacesById)) {
    const model = modelsById[workspace.componentModel];
    componentTypesByWorkspaceId[workspaceId] = Object.values(
      modelOperations.getComponentTypes(model).componentTypesById
    );
  }
  return componentTypesByWorkspaceId;
};

export const componentTypesByWorkspaceId$ = workspaceAndModel$.pipe(
  map(buildComponentTypesByWorkspaceId),
  distinctUntilChanged(isEqual),
  shareReplay({ bufferSize: 1, refCount: true })
);
